import { render, staticRenderFns } from "./settings-user-contact-view.vue?vue&type=template&id=79f6cc0b&"
import script from "./settings-user-contact-view.vue?vue&type=script&lang=js&"
export * from "./settings-user-contact-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports